import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import {
  AutomationProjectionsPayload,
  AutomationProjectionsQuery,
} from '@rossum/api-client/queues';
import { api } from '../../../../../lib/apiClient';

export const GET_AUTOMATION_PROJECTIONS_QUERY_KEY =
  'get-automation-projections';

export const useGetAutomationProjections = ({
  queueId,
  enabled,
  payload,
  query,
}: {
  enabled: boolean;
  queueId: number;
  payload: AutomationProjectionsPayload;
  query: AutomationProjectionsQuery;
}) => {
  return useQuery({
    queryKey: [GET_AUTOMATION_PROJECTIONS_QUERY_KEY, queueId, payload, query],
    queryFn: () => {
      return api.request(
        endpoints.queues.automationProjections(queueId, payload, query)
      );
    },
    // Baseline projections only need to refetch on query changes or after an
    // explicit invalidation post-save. Toggling automation level only flips
    // `enabled` — we don't want that to refire the request.
    staleTime: Infinity,
    enabled,
  });
};
